import { useEffect, useState } from "react";
import { getData } from "../utils/apiCalls";
import { CarouselSlider } from './CarouselSlider';
// import { Loader } from "./Loader";
import testimonials_overview from '../data/testimonials_overview.json'
import testimonials_startups from '../data/testimonials_startups.json'


export const TestimonialCarousel = ({ pageName }) => {
   const [data, setData] = useState([])
   // const [isLoading, setIsLoading] = useState(true)

   useEffect(() => {
      // getData('https://youngstartup.io/api/cwebsite/get_testimonials?page=' + pageName)
      //    .then(res => { setData(res) })
      //    .then(() => { setIsLoading(false) })
      if (pageName.includes('overview')) setData(testimonials_overview)
      else setData(testimonials_startups)
   }, [pageName]);

   return (
      <div className="testimonial-carousel">
         {/* {isLoading && <Loader color='dark1' />} */}
          <CarouselSlider data={data} >
            {
               data.map((item, index) => (
                  <div key={index} className='testimonial-slide'>
                     <section className="testimonial">
                        <h1>"{item.content}"</h1>
                        <h5>{item.name}, {item.company}</h5>
                        <img src={item.image_url} alt={item.image_url} />
                     </section>
                  </div>
               ))
            }
         </CarouselSlider>
      </div>
   )
}
